import Request from '../request';
import { extend } from 'lodash';

class ApiModule {
  public name;
  public endpoint;
  public path;
  public appendedUrl;
  public params;
  public payloadPath;
  public query;

  constructor(parameters) {
    extend(this, parameters);
  }

  getName = () => {
    return this.name;
  };

  createRequest = (args = {}) => {
    const {
      name,
      endpoint,
      path = '',
      appendedUrl = '',
      params,
      payloadPath,
    } = this;

    return new Request({
      name,
      endpoint,
      path,
      appendedUrl,
      params,
      payloadPath,
      ...args,
    });
  };

  setQuery = (query) => {
    return this.createRequest({ query: { ...query, ...this.query } });
  };

  setBody = (body) => {
    return this.createRequest({ body });
  };

  setParams = (parameters) => {
    return this.createRequest({ params: parameters });
  };

  hasParam = (key) => this.params[key];

  appendUrl = (appendedUrl = '') => {
    return this.createRequest({ appendedUrl });
  };

  get = (data?) => {
    return this.createRequest().get(data);
  };

  post = (data) => {
    return this.createRequest().post(data);
  };

  put = (data) => {
    return this.createRequest().put(data);
  };

  patch = (data) => {
    return this.createRequest().patch(data);
  };

  delete = (data) => {
    return this.createRequest().delete(data);
  };

  getCrudActions = () => ({
    create: this.post,
    update: this.patch,
    delete: this.delete,
    read: this.get,
  });
}

export default ApiModule;
